import React from "react";
import Link from "next/link";

import { links } from "../../helper/constants";
import { event } from "../../lib/gtag";

import styles from "./styles.module.scss";

interface EVShowBannerProps {
	staticBanner?: boolean;
	financePage?: boolean;
}

export default function EVShowBanner({ staticBanner, financePage }: EVShowBannerProps) {
	return (
		<div className={`${styles.banner} ${staticBanner && styles.staticBanner} ${financePage && styles.financePageBanner}`}>
			<p className={`${styles.text}`}>
				<Link href={links.ev_talk_show_page} passHref>
					<a className={styles.link} onClick={() => event("evShowBlueTopBannerRegisterClick")}>
						<p className={styles.mediumWeight}>Now Live – Get your free ticket for the Nevo Driving Experience at The Curragh Racecourse on Sunday, June 15th</p>
					</a>
				</Link>
			</p>
		</div>
	);
}
